import dayjs from 'dayjs'
import 'dayjs/locale/vi' // nếu bạn muốn hiển thị tiếng Việt
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.locale('vi') // set ngôn ngữ hiển thị
dayjs.extend(quarterOfYear)

export const getTimeFromNow = (time: string, timeZone?: number) => {
  const date = dayjs(time).add(timeZone ?? 7, 'hours')
  const diffDays = dayjs().diff(date, 'day') // số ngày chênh lệch

  if (diffDays > 7) {
    // Nếu hơn 7 ngày thì trả về ngày cụ thể
    return date.format('DD/MM/YYYY')
  }

  // Ngược lại thì trả về dạng relative
  return date.fromNow() ?? 'vừa xong'
}
export function formatTime(seconds: number | string) {
  const numSeconds = typeof seconds === 'string' ? parseInt(seconds) : seconds
  const dur = dayjs.duration(numSeconds, 'seconds')
  if (numSeconds >= 3600) {
    return dur.format('HH:mm:ss')
  } else {
    return dur.format('mm:ss')
  }
}

export const formatDateToHours = (dateString: string, format?: string) => {
  // Parse đúng format: HH:mm:ss DD/MM/YYYY
  const time = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss', true).isValid()
    ? dayjs(dateString, 'YYYY-MM-DD HH:mm:ss')
    : dayjs(dateString)
  const hours = time.get('hour').toString().padStart(2, '0')
  return `${hours}h ${time.format(format || 'DD/MM/YYYY')}`
}

/**
 * Lấy quý hiện tại (1-4)
 * @returns 1 | 2 | 3 | 4
 */
export const getCurrentQuarter = (): number => {
  return dayjs().quarter()
}
